var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"404 c",staticStyle:{"flex-direction":"column","background":"#f9fbfa"}},[_c('img',{attrs:{"src":"/images/404.png","width":"250","height":"125"}}),_c('h1',[_vm._v("页面走丢了")]),_c('a',{staticStyle:{"margin-top":"20px"},attrs:{"href":"/"}},[_vm._v("回到首页")])])
}]

export { render, staticRenderFns }